import getKhattabatStore from "../../../../../../../stores/khattabat-stores";
import { TalkhattabatConversationType } from "../../../../../../../Types";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../../../core/et3-ui/ET3Margin";
import CreateOneOTwoButton from "./CreateOneOTwoButton";
import CreateOneOTwoField from "./CreateOneOTwoField";
import getCorePersonalStore from "../../../../../../../stores/core/core-personal-store";

const CreateOneOTwoConversation = withLiteObserverAndTheme<{
  conversationID: string;
  conversationType: TalkhattabatConversationType;
  alkhattabaUUID: string;
  userUUID: string;
  userID: number;
  isValidSubscription: boolean;
  oneOOneCId: string
}>((props) => {
  const {
    theme,
    conversationType,
    conversationID,
    alkhattabaUUID,
    userUUID,
    isValidSubscription,
    userID,
    oneOOneCId
  } = props;
  const { colors } = theme;
  const isKhattabaAiAdmin = getCorePersonalStore().isKhattabaAiAdmin.get()
  const isPaidConversation = getKhattabatStore().conversationsClientType.get() === "PAID"
  const isOneOOneCConversation = conversationType === "101C"

  const shouldShow = !isKhattabaAiAdmin && isPaidConversation && isOneOOneCConversation
    ;

  return shouldShow ? (
    <ET3Div
      width={180}
      height={93}
      alignItems={"center"}
      fDirection={"column"}
      style={{ backgroundColor: colors.all.white }}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => { }}
    >
      <CreateOneOTwoField
        conversationType={conversationType}
        conversationID={conversationID}
      />
      <Et3Margin top={5} bottom={5} left={0} right={0} />
      <CreateOneOTwoButton
        conversationType={conversationType}
        conversationID={conversationID}
        alkhattabaUUID={alkhattabaUUID}
        userUUID={userUUID}
        userID={userID}
        isValidSubscription={isValidSubscription}
        oneOOneCId={oneOOneCId}
      />
    </ET3Div>
  ) : null;
});

export default CreateOneOTwoConversation;
